<template>
    <div class="infoengine">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Nationality Factor</h2>
                </div>
                <div class="col-md-7 text-right">
                    <div class="row">
                        <div class="col-md-6">
                            <base-search
                                placeholder="Search nationality"
                                @keyword="getKeyword"
                            ></base-search>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="apply"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-8">
                                    <b-button
                                        type="button"
                                        variant="secondary"
                                        class="secondary-add-btn"
                                        @click="
                                            $bvModal.show(
                                                'add-nationality-popup'
                                            )
                                        "
                                    >
                                        <span class="btn-text"
                                            >+ Add Nationality</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-small-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="rating" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="isSanction" slot-scope="data">
                    <span>
                        {{ data.value | booleanText }}
                    </span>
                </template>

                <template slot="status" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-nationality-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            :icon="
                                data.value == 'active'
                                    ? 'icon-trash'
                                    : 'icon-done'
                            "
                            :label="
                                data.value == 'active' ? 'Archive' : 'Activate'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('status-update-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <!-- Get list records -->
        <base-records
            path="configurations/nationalities"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <!-- Add nationality popup  -->
        <add-nationality-popup
            :title="title"
            :button-text="buttonText"
        ></add-nationality-popup>
        <!-- Archive popup -->
        <archive-popup
            title="Archive Nationality Factor"
            description="Are you sure you want to archive this nationality factor? You can re-activate it later."
        ></archive-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import addNationalityPopup from '@/components/popups/AddNationalityPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        addNationalityPopup,
        archivePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'Nationality Code',
                    sortable: true,
                },
                {
                    key: 'title',
                    label: 'Nationality Title',
                    sortable: true,
                    formatter: (value) => {
                        return _.startCase(value)
                    },
                },
                {
                    key: 'rating',
                    label: 'RATING',
                    class: 'text-center rating-field status-absolute-pos',
                    sortable: true,
                },
                {
                    key: 'isSanction',
                    label: 'IS SANCTION',
                    class: 'text-center',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list',
                },
            ],
            title: 'Add Nationality Factor',
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'title',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            buttonText: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        },
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
